import { motion } from "framer-motion";
import { Ticket } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { TICKET_SHOP_URL } from "@/lib/media";

export default function FloatingTicket() {
  const { t } = useLang();
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 2.8, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-6 right-6 z-[80]"
    >
      <a
        href={TICKET_SHOP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-ticket-btn"
        className="flex items-center gap-2.5 rounded-full bg-hell-red hover:bg-hell-redhot text-hell-bone font-cinzel text-xs tracking-[0.15em] uppercase pl-4 pr-6 h-14 shadow-[0_0_28px_rgba(139,0,0,0.65)] hover:shadow-[0_0_40px_rgba(185,28,28,0.8)] transition-all duration-300 hover:-translate-y-0.5 animate-pulse [animation-duration:3s]"
      >
        <Ticket className="w-5 h-5" />
        {t("nav_cta")}
      </a>
    </motion.div>
  );
}
